
// // // // import React, { useState } from 'react';
// // // // import { useAuth } from '../App';
// // // // import { Link, useNavigate } from 'react-router-dom';
// // // // import { Button } from './ui/button';
// // // // import { Bell, LogOut, Menu, X } from 'lucide-react';

// // // // export default function Layout({ children, title }) {
// // // //   const { user, logout } = useAuth();
// // // //   const navigate = useNavigate();
// // // //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// // // //   const handleLogout = () => {
// // // //     logout();
// // // //     navigate('/login');
// // // //   };

// // // //   // Navbar selon rôle
// // // //   let navItems = [];
// // // //   if (user?.role === 'admin') {
// // // //     navItems = [
// // // //       { path: '/dashboard', label: 'Dashboard' },
// // // //       { path: '/users', label: 'Utilisateurs' },
// // // //       { path: '/institutions', label: 'Établissements' },
// // // //       { path: '/prestations', label: 'Prestations' },
// // // //       // { path: '/schedules', label: 'Horaires' },
// // // //       // { path: '/teams', label: 'Équipes' },
// // // //       { path: '/profile', label: 'Profile' },
// // // //       // { path: '/payslips', label: 'Fiches de paie' },
// // // //       { path: '/payrolls', label: 'Facturations' },
// // // //       // { path: '/messages', label: 'Messages' },
// // // //       { path: '/notifications', label: 'Notifications' },
// // // //       { path: '/soins', label: 'Soins à domicile' },

// // // //     ];
// // // //   } else if (user?.role === 'institution') {
// // // //     navItems = [
// // // //       { path: '/institution-dashboard', label: 'Dashboard' },
// // // //       // { path: '/prestations', label: 'Prestations' },
// // // //       { path: '/institution-dashboard/tarifications', label: 'Tarifications' },
// // // //       { path: '/profile', label: 'Profil' },
// // // //       { path: '/payrolls', label: 'Facturation' },
// // // //     ];
// // // //   } 
// // // //   else if (user?.role === 'coordinateur') {
// // // //   navItems = [
// // // //     { path: '/dashboard', label: 'Dashboard' },
// // // //     { path: '/prestations', label: 'Prestations' },
// // // //     { path: '/schedules', label: 'Horaires' },
// // // //     { path: '/messages', label: 'Messages' },
// // // //     { path: '/profile', label: 'Profile' },
// // // //     { path: '/notifications', label: 'Notifications' },
// // // //     { path: '/soins', label: 'Soins à domicile' },
// // // //   ];
// // // // }
// // // //   else {
// // // //     // utilisateur classique
// // // //     navItems = [
// // // //       { path: '/dashboard', label: 'Dashboard' },
// // // //       { path: '/prestations', label: 'Prestations' },
// // // //       { path: '/schedules', label: 'Horaires' },
// // // //       // { path: '/messages', label: 'Messages' },
// // // //       // { path: '/exchanges', label: 'Échanges' },
// // // //       // { path: '/payslips', label: 'Fiches de paie' },
// // // //       { path: '/user-payrolls', label: 'Facturations' },
// // // //       // { path: '/teams', label: 'Équipes' },
// // // //       { path: '/profile', label: 'Profile' },
// // // //       { path: '/notifications', label: 'Notifications' },
// // // //       { path: '/soins', label: 'Soins à domicile' },

// // // //     ];
// // // //   }

// // // //   return (
// // // //     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
// // // //       {/* Navbar */}
// // // //       <nav className="navbar">
// // // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
// // // //           {/* Logo */}
// // // //           <Link to={user?.role === 'institution' ? '/institution-dashboard' : '/dashboard'}>
// // // //             <h1 className="text-2xl font-bold text-amber-700" style={{ fontFamily: 'Playfair Display, serif' }}>
// // // //               Sana-Care
// // // //             </h1>
// // // //           </Link>

// // // //           {/* Desktop menu */}
// // // //           <div className="hidden md:flex space-x-4">
// // // //             {navItems.map(item => (
// // // //               <Link
// // // //                 key={item.path}
// // // //                 to={item.path}
// // // //                 className="px-3 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-amber-100 hover:text-amber-900 transition"
// // // //               >
// // // //                 {item.label}
// // // //               </Link>
// // // //             ))}
// // // //           </div>

// // // //           {/* User actions */}
// // // //           <div className="hidden md:flex items-center space-x-4">
// // // //             <Link to="/notifications">
// // // //               <Button variant="ghost" size="icon">
// // // //                 <Bell className="text-amber-700" />
// // // //               </Button>
// // // //             </Link>

// // // //             <div className="flex items-center space-x-2">
// // // //               <div className="text-right">
// // // //                 <p className="text-sm font-semibold text-amber-900">{user?.first_name} {user?.last_name}</p>
// // // //                 <p className="text-xs text-gray-600">{user?.role}</p>
// // // //               </div>
// // // //             </div>

// // // //             <Button onClick={handleLogout} variant="outline" size="sm" className="border-amber-600 text-amber-700 hover:bg-amber-100">
// // // //               <LogOut size={16} className="mr-1" /> Déconnexion
// // // //             </Button>
// // // //           </div>

// // // //           {/* Mobile menu button */}
// // // //           <div className="md:hidden">
// // // //             <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
// // // //               {mobileMenuOpen ? <X /> : <Menu />}
// // // //             </Button>
// // // //           </div>
// // // //         </div>

// // // //         {/* Mobile menu */}
// // // //         {mobileMenuOpen && (
// // // //           <div className="md:hidden bg-white border-t border-amber-200">
// // // //             <div className="px-2 pt-2 pb-3 space-y-1">
// // // //               {navItems.map(item => (
// // // //                 <Link
// // // //                   key={item.path}
// // // //                   to={item.path}
// // // //                   className="block px-3 py-2 rounded-lg text-base font-medium text-gray-700 hover:bg-amber-100"
// // // //                   onClick={() => setMobileMenuOpen(false)}
// // // //                 >
// // // //                   {item.label}
// // // //                 </Link>
// // // //               ))}
// // // //               <Button onClick={handleLogout} variant="outline" className="w-full mt-2 border-amber-600 text-amber-700">
// // // //                 Déconnexion
// // // //               </Button>
// // // //             </div>
// // // //           </div>
// // // //         )}
// // // //       </nav>

// // // //       {/* Main content */}
// // // //       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// // // //         {title && (
// // // //           <h1 className="text-4xl font-bold text-amber-800 mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
// // // //             {title}
// // // //           </h1>
// // // //         )}
// // // //         {children}
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // }


// // // import React, { useState } from 'react';
// // // import { useAuth } from '../App';
// // // import { Link, useNavigate } from 'react-router-dom';
// // // import { Button } from './ui/button';
// // // import { Bell, LogOut, Menu, X } from 'lucide-react';
// // // import logo from './logo.jpeg';

// // // export default function Layout({ children, title }) {
// // //   const { user, logout } = useAuth();
// // //   const navigate = useNavigate();
// // //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  

// // //   const handleLogout = () => {
// // //     logout();
// // //     navigate('/login');
// // //   };

// // //   const role = user?.role?.toLowerCase();
// // //   const appliRole = user?.appli_role?.toLowerCase();
// // //   const isChef = appliRole === 'chef';

// // //   // Navbar selon rôle
// // //   let navItems = [];  

// // //   if (role === 'admin') {

// // //     navItems = [
// // //       { path: '/dashboard', label: 'Dashboard' },
// // //       { path: '/users', label: 'Utilisateurs' },
// // //       { path: '/institutions', label: 'Établissements' },
// // //       { path: '/prestations', label: 'Prestations' },
// // //       { path: '/profile', label: 'Profil' },
// // //       // { path: '/payrolls', label: 'Facturations' },
// // //       // { path: '/notifications', label: 'Notifications' },
// // //       { path: '/admin-notifications', label: 'Admin notifs' },
// // //       { path: '/admin-echanges', label: 'Echanges prestations' },
// // //       { path: '/soins', label: 'Soins à domicile' },
// // //     ];
// // //   }
// // //   else if (isChef) {
// // //     navItems = [
// // //       // { path: '/dashboard', label: 'Dashboard' },
// // //       // { path: '/users', label: 'Utilisateurs' },
// // //       // { path: '/institutions', label: 'Établissements' },
// // //       { path: '/prestations', label: 'Prestations' },
// // //       { path: '/prestations-admin', label: 'Prestations admin' },
// // //       { path: '/user-payrolls', label: 'Facturations' },
// // //       { path: '/profile', label: 'Profil' },
// // //       // { path: '/notifications', label: 'Notifications' },
// // //       { path: '/soins', label: 'Soins à domicile' },
// // //     ];
// // //   }   else if (role === 'coordinateur') {
// // //     navItems = [
// // //       // { path: '/dashboard', label: 'Dashboard' },
// // //       { path: '/prestations', label: 'Prestations' },
// // //       { path: '/schedules', label: 'Horaires' },
// // //       // { path: '/messages', label: 'Messages' },
// // //       { path: '/profile', label: 'Profil' },
// // //       // { path: '/notifications', label: 'Notifications' },
// // //       { path: '/soins', label: 'Soins à domicile' },
// // //     ];
// // //   } else if (role === 'institution') {
// // //     navItems = [
// // //       { path: '/institution-dashboard', label: 'Dashboard' },
// // //       { path: '/institution-dashboard/tarifications', label: 'Tarifications' },
// // //       { path: '/profile', label: 'Profil' },
// // //       { path: '/payrolls', label: 'Facturation' },
// // //     ];
// // //   } else if (['nurse', 'caregiver'].includes(role)) {
// // //     navItems = [
// // //       // { path: '/dashboard', label: 'Dashboard' },
// // //       { path: '/prestations', label: 'Prestations' },
// // //       // { path: '/schedules', label: 'Horaires' },
// // //       { path: '/user-payrolls', label: 'Facturations' },
// // //       { path: '/mes-echanges', label: 'Mes échanges' },
// // //       // { path: '/notifications', label: 'Notifications' },
// // //       { path: '/soins', label: 'Soins à domicile' },
// // //       { path: '/profile', label: 'Profil' },
// // //     ];
// // //   } else {
// // //     // Utilisateur standard
// // //     navItems = [
// // //       { path: '/dashboard', label: 'Dashboard' },
// // //       { path: '/prestations', label: 'Prestations' },
// // //       { path: '/profile', label: 'Profil' },
// // //       { path: '/notifications', label: 'Notifications' },
// // //       { path: '/soins', label: 'Soins à domicile' },
// // //     ];
// // //   }

// // //   return (
// // //     <div className="min-h-screen bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
// // //       {/* Navbar */}
// // //       <nav className="navbar">
// // //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
// // //           {/* Logo */}
// // //           {/* <Link to={role === 'institution' ? '/institution-dashboard' : '/dashboard'}>
// // //             <h1 className="text-2xl font-bold text-amber-700" style={{ fontFamily: 'Playfair Display, serif' }}>
// // //               Sana-Care
// // //             </h1>
// // //           </Link> */}
// // //           <Link
// // //             to={role === 'institution' ? '/institution-dashboard' : '/dashboard'}
// // //             className="flex items-center"
// // //           >
// // //             <img
// // //               src={logo}
// // //               alt="SanaCare"
// // //               className="h-16 w-auto object-contain"
// // //             />
// // //           </Link>

// // //           {/* Desktop menu */}
// // //           <div className="hidden md:flex space-x-4">
// // //             {navItems.map(item => (
// // //               <Link
// // //                 key={item.path}
// // //                 to={item.path}
// // //                 className="px-3 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-amber-100 hover:text-amber-900 transition"
// // //               >
// // //                 {item.label}
// // //               </Link>
// // //             ))}
// // //           </div>

// // //           {/* User actions */}
// // //           <div className="hidden md:flex items-center space-x-4">
// // //             {/* <Link to={role === 'admin' ? '/admin-notifications' : '/notifications'}>
// // //               <Button variant="ghost" size="icon">
// // //                 <Bell className="text-amber-700" />
// // //               </Button>
// // //             </Link> */}
// // //               {/* <Link to="/notifications">
// // //                 <Button variant="ghost" size="icon">
// // //                   <Bell className="text-amber-700" />
// // //                 </Button>
// // //               </Link> */}

// // //             <div className="flex items-center space-x-2">
// // //               <div className="text-right">
// // //                 <p className="text-sm font-semibold text-amber-900">{user?.first_name} {user?.last_name}</p>
// // //                 <p className="text-xs text-gray-600">{user?.role}</p>
// // //               </div>
// // //             </div>

// // //             <Button onClick={handleLogout} variant="outline" size="sm" className="border-amber-600 text-amber-700 hover:bg-amber-100">
// // //               <LogOut size={16} className="mr-1" /> Déconnexion
// // //             </Button>
// // //           </div>

// // //           {/* Mobile menu button */}
// // //           <div className="md:hidden">
// // //             <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
// // //               {mobileMenuOpen ? <X /> : <Menu />}
// // //             </Button>
// // //           </div>
// // //         </div>

// // //         {/* Mobile menu */}
// // //         {mobileMenuOpen && (
// // //           <div className="md:hidden bg-white border-t border-amber-200">
// // //             <div className="px-2 pt-2 pb-3 space-y-1">
// // //               {navItems.map(item => (
// // //                 <Link
// // //                   key={item.path}
// // //                   to={item.path}
// // //                   className="block px-3 py-2 rounded-lg text-base font-medium text-gray-700 hover:bg-amber-100"
// // //                   onClick={() => setMobileMenuOpen(false)}
// // //                 >
// // //                   {item.label}
// // //                 </Link>
// // //               ))}
// // //               <Button onClick={handleLogout} variant="outline" className="w-full mt-2 border-amber-600 text-amber-700">
// // //                 Déconnexion
// // //               </Button>
// // //             </div>
// // //           </div>
// // //         )}
// // //       </nav>

// // //       {/* Main content */}
// // //       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
// // //         {title && (
// // //           <h1 className="text-4xl font-bold text-amber-800 mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
// // //             {title}
// // //           </h1>
// // //         )}
// // //         {children}
// // //       </main>
// // //     </div>
// // //   );
// // // }


// // import React, { useState } from 'react';
// // import { useAuth } from '../App';
// // import { Link, useNavigate } from 'react-router-dom';
// // import { Button } from './ui/button';
// // import { Bell, LogOut, Menu, X } from 'lucide-react';
// // import logo from './logo.jpeg';

// // export default function Layout({ children, title }) {
// //   const { user, logout } = useAuth();
// //   const navigate = useNavigate();
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

// //   const handleLogout = () => {
// //     logout();
// //     navigate('/login');
// //   };

// //   const role = user?.role?.toLowerCase();
// //   const appliRole = user?.appli_role?.toLowerCase();
// //   const isChef = appliRole === 'chef';

// //   // Navbar selon rôle
// //   let navItems = [];

// //   if (role === 'admin') {
// //     navItems = [
// //       { path: '/dashboard', label: 'Dashboard' },
// //       { path: '/users', label: 'Utilisateurs' },
// //       { path: '/institutions', label: 'Établissements' },
// //       { path: '/prestations', label: 'Prestations' },
// //       { path: '/profile', label: 'Profil' },
// //       // { path: '/payrolls', label: 'Facturations' },
// //       // { path: '/notifications', label: 'Notifications' },
// //       { path: '/admin-notifications', label: 'Admin notifs' },
// //       { path: '/admin-echanges', label: 'Echanges prestations' },
// //       { path: '/soins', label: 'Soins à domicile' },
// //     ];
// //   } else if (isChef) {
// //     navItems = [
// //       // { path: '/dashboard', label: 'Dashboard' },
// //       // { path: '/users', label: 'Utilisateurs' },
// //       // { path: '/institutions', label: 'Établissements' },
// //       { path: '/prestations', label: 'Prestations' },
// //       { path: '/prestations-admin', label: 'Prestations admin' },
// //       { path: '/user-payrolls', label: 'Facturations' },
// //       { path: '/profile', label: 'Profil' },
// //       // { path: '/notifications', label: 'Notifications' },
// //       { path: '/soins', label: 'Soins à domicile' },
// //     ];
// //   } else if (role === 'coordinateur') {
// //     navItems = [
// //       // { path: '/dashboard', label: 'Dashboard' },
// //       { path: '/prestations', label: 'Prestations' },
// //       { path: '/schedules', label: 'Horaires' },
// //       // { path: '/messages', label: 'Messages' },
// //       { path: '/profile', label: 'Profil' },
// //       // { path: '/notifications', label: 'Notifications' },
// //       { path: '/soins', label: 'Soins à domicile' },
// //     ];
// //   } else if (role === 'institution') {
// //     navItems = [
// //       { path: '/institution-dashboard', label: 'Dashboard' },
// //       { path: '/institution-dashboard/tarifications', label: 'Tarifications' },
// //       { path: '/profile', label: 'Profil' },
// //       { path: '/payrolls', label: 'Facturation' },
// //     ];
// //   } else if (['nurse', 'caregiver'].includes(role)) {
// //     navItems = [
// //       // { path: '/dashboard', label: 'Dashboard' },
// //       { path: '/prestations', label: 'Prestations' },
// //       // { path: '/schedules', label: 'Horaires' },
// //       { path: '/user-payrolls', label: 'Facturations' },
// //       { path: '/mes-echanges', label: 'Mes échanges' },
// //       // { path: '/notifications', label: 'Notifications' },
// //       { path: '/soins', label: 'Soins à domicile' },
// //       { path: '/profile', label: 'Profil' },
// //     ];
// //   } else {
// //     // Utilisateur standard
// //     navItems = [
// //       { path: '/dashboard', label: 'Dashboard' },
// //       { path: '/prestations', label: 'Prestations' },
// //       { path: '/profile', label: 'Profil' },
// //       { path: '/notifications', label: 'Notifications' },
// //       { path: '/soins', label: 'Soins à domicile' },
// //     ];
// //   }

// //   return (
// //     <div className="min-h-screen bg-gradient-to-br from-blue-50 via-sky-50 to-slate-50">

// //       {/* =========================
// //           NAVBAR
// //           ========================= */}

// //       <nav className="navbar">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">

// //           {/* Logo */}
// //           <Link
// //             to={role === 'institution' ? '/institution-dashboard' : '/dashboard'}
// //             className="flex items-center"
// //           >
// //             <img
// //               src={logo}
// //               alt="SanaCare"
// //               className="h-16 w-auto object-contain"
// //             />
// //           </Link>

// //           {/* =========================
// //               DESKTOP MENU
// //               ========================= */}

// //           <div className="hidden md:flex space-x-4">
// //             {navItems.map(item => (
// //               <Link
// //                 key={item.path}
// //                 to={item.path}
// //                 className="px-3 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-blue-100 hover:text-blue-900 transition"
// //               >
// //                 {item.label}
// //               </Link>
// //             ))}
// //           </div>

// //           {/* =========================
// //               USER ACTIONS
// //               ========================= */}

// //           <div className="hidden md:flex items-center space-x-4">

// //             {/* Notifications désactivées pour le moment */}
// //             {/* 
// //             <Link to={role === 'admin' ? '/admin-notifications' : '/notifications'}>
// //               <Button variant="ghost" size="icon">
// //                 <Bell className="text-blue-700" />
// //               </Button>
// //             </Link>
// //             */}

// //             <div className="flex items-center space-x-2">
// //               <div className="text-right">
// //                 <p className="text-sm font-semibold text-blue-900">
// //                   {user?.first_name} {user?.last_name}
// //                 </p>

// //                 <p className="text-xs text-gray-600">
// //                   {user?.role}
// //                 </p>
// //               </div>
// //             </div>

// //             <Button
// //               onClick={handleLogout}
// //               variant="outline"
// //               size="sm"
// //               className="border-blue-600 text-blue-700 hover:bg-blue-100 hover:text-blue-900"
// //             >
// //               <LogOut size={16} className="mr-1" />
// //               Déconnexion
// //             </Button>
// //           </div>

// //           {/* =========================
// //               MOBILE MENU BUTTON
// //               ========================= */}

// //           <div className="md:hidden">
// //             <Button
// //               variant="ghost"
// //               size="icon"
// //               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
// //             >
// //               {mobileMenuOpen ? <X /> : <Menu />}
// //             </Button>
// //           </div>
// //         </div>

// //         {/* =========================
// //             MOBILE MENU
// //             ========================= */}

// //         {mobileMenuOpen && (
// //           <div className="md:hidden bg-white border-t border-blue-200">

// //             <div className="px-2 pt-2 pb-3 space-y-1">

// //               {navItems.map(item => (
// //                 <Link
// //                   key={item.path}
// //                   to={item.path}
// //                   className="block px-3 py-2 rounded-lg text-base font-medium text-gray-700 hover:bg-blue-100 hover:text-blue-900 transition"
// //                   onClick={() => setMobileMenuOpen(false)}
// //                 >
// //                   {item.label}
// //                 </Link>
// //               ))}

// //               <Button
// //                 onClick={handleLogout}
// //                 variant="outline"
// //                 className="w-full mt-2 border-blue-600 text-blue-700 hover:bg-blue-100 hover:text-blue-900"
// //               >
// //                 <LogOut size={16} className="mr-2" />
// //                 Déconnexion
// //               </Button>

// //             </div>
// //           </div>
// //         )}
// //       </nav>

// //       {/* =========================
// //           MAIN CONTENT
// //           ========================= */}

// //       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

// //         {title && (
// //           <h1
// //             className="text-4xl font-bold text-blue-900 mb-8"
// //             style={{ fontFamily: 'Playfair Display, serif' }}
// //           >
// //             {title}
// //           </h1>
// //         )}

// //         {children}

// //       </main>
// //     </div>
// //   );
// // }


// import React, { useState } from 'react';
// import { useAuth } from '../App';
// import { Link, useNavigate } from 'react-router-dom';
// import { Button } from './ui/button';
// import { Bell, LogOut, Menu, X } from 'lucide-react';
// import logo from './logo.jpeg';

// export default function Layout({ children, title }) {
//   const { user, logout } = useAuth();
//   const navigate = useNavigate();
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const role = user?.role?.toLowerCase();
//   const appliRole = user?.appli_role?.toLowerCase();
//   const isChef = appliRole === 'chef';

//   let navItems = [];

//   if (role === 'admin') {
//     navItems = [
//       { path: '/dashboard', label: 'Acceuil' },
//       { path: '/users', label: 'Utilisateurs' },
//       { path: '/institutions', label: 'Établissements' },
//       { path: '/prestations', label: 'Prestations' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/admin-notifications', label: 'Admin notifs' },
//       { path: '/admin-echanges', label: 'Echanges prestations' },
//       { path: '/soins', label: 'Soins à domicile' },
//       { path: '/direction', label: 'Dashboard-Direction' },
//     ];
//   } else if (isChef) {
//     navItems = [
//       { path: '/prestations', label: 'Prestations' },
//       { path: '/prestations-admin', label: 'Prestations admin' },
//       { path: '/institutions', label: 'Établissements' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/soins', label: 'Soins à domicile' },
//       { path: '/user-payrolls', label: 'Facturations' },
//     ];
//   } else if (role === 'coordinateur') {
//     navItems = [
//       { path: '/prestations', label: 'Prestations' },
//       // { path: '/schedules', label: 'Horaires' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/soins', label: 'Soins à domicile' },
//     ];
//   } else if (role === 'institution') {
//     navItems = [
//       { path: '/institution-dashboard', label: 'Dashboard' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/institution-dashboard/tarifications', label: 'Tarifications' },
//       { path: '/payrolls', label: 'Facturation' },
//     ];
//   } else if (['nurse', 'caregiver'].includes(role)) {
//     navItems = [
//       { path: '/prestations', label: 'Mes Prestations' },
//       // { path: '/mes-echanges', label: 'Mes échanges' },
//       // { path: '/soins', label: 'Soins à domicile' },
//       { path: '/soins', label: 'Soins à domicile' },
//       // { path: '/ma-tournee', label: 'Ma tournée' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/user-payrolls', label: 'Facturations' },
//     ];
//   } else {
//     navItems = [
//       { path: '/dashboard', label: 'Dashboard' },
//       { path: '/prestations', label: 'Prestations' },
//       { path: '/profile', label: 'Profil' },
//       { path: '/notifications', label: 'Notifications' },
//       { path: '/soins', label: 'Soins à domicile' },
//     ];
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-[#F2F9F9] via-[#D4EBEB] to-[#E8F4F4]">

//       {/* =========================
//           NAVBAR
//           ========================= */}

//       <nav className="navbar">

//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">

//           {/* Logo */}

//           <Link
//             to={role === 'institution' ? '/institution-dashboard' : '/dashboard'}
//             className="flex items-center"
//           >
//             <img
//               src={logo}
//               alt="SanaCare"
//               className="h-16 w-auto object-contain"
//             />
//           </Link>

//           {/* =========================
//               DESKTOP MENU
//               ========================= */}

//           <div className="hidden md:flex space-x-2">

//             {navItems.map(item => (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 className="
//                   px-3 py-2
//                   rounded-lg
//                   text-sm
//                   font-medium
//                   text-[#3F5F5F]
//                   hover:bg-[#D4EBEB]
//                   hover:text-[#294A4A]
//                   transition
//                 "
//               >
//                 {item.label}
//               </Link>
//             ))}

//           </div>

//           {/* =========================
//               USER ACTIONS
//               ========================= */}

//           <div className="hidden md:flex items-center space-x-4">

//             {/* Notifications */}

//             {/*
//             <Link to={role === 'admin' ? '/admin-notifications' : '/notifications'}>
//               <Button variant="ghost" size="icon">
//                 <Bell className="text-[#6FAFAF]" />
//               </Button>
//             </Link>
//             */}

//             <div className="flex items-center space-x-2">

//               <div className="text-right">

//                 <p className="text-sm font-semibold text-[#3F7373]">
//                   {user?.first_name} {user?.last_name}
//                 </p>

//                 <p className="text-xs text-[#647878]">
//                   {user?.role}
//                 </p>

//               </div>

//             </div>

//             {/* Déconnexion */}

//             <Button
//               onClick={handleLogout}
//               variant="outline"
//               size="sm"
//               className="
//                 border-[#8FBDBD]
//                 text-[#4F8585]
//                 bg-white
//                 hover:bg-[#D4EBEB]
//                 hover:text-[#294A4A]
//                 hover:border-[#6FAFAF]
//               "
//             >
//               <LogOut size={16} className="mr-1" />
//               Déconnexion
//             </Button>

//           </div>

//           {/* =========================
//               MOBILE BUTTON
//               ========================= */}

//           <div className="md:hidden">

//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//               className="text-[#4F8585] hover:bg-[#D4EBEB]"
//             >
//               {mobileMenuOpen ? <X /> : <Menu />}
//             </Button>

//           </div>

//         </div>

//         {/* =========================
//             MOBILE MENU
//             ========================= */}

//         {mobileMenuOpen && (

//           <div className="md:hidden bg-white border-t border-[#C1DDDD]">

//             <div className="px-2 pt-2 pb-3 space-y-1">

//               {navItems.map(item => (

//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className="
//                     block
//                     px-3
//                     py-2
//                     rounded-lg
//                     text-base
//                     font-medium
//                     text-[#3F5F5F]
//                     hover:bg-[#D4EBEB]
//                     hover:text-[#294A4A]
//                     transition
//                   "
//                   onClick={() => setMobileMenuOpen(false)}
//                 >
//                   {item.label}
//                 </Link>

//               ))}

//               <Button
//                 onClick={handleLogout}
//                 variant="outline"
//                 className="
//                   w-full
//                   mt-2
//                   border-[#8FBDBD]
//                   text-[#4F8585]
//                   hover:bg-[#D4EBEB]
//                   hover:text-[#294A4A]
//                 "
//               >
//                 <LogOut size={16} className="mr-2" />
//                 Déconnexion
//               </Button>

//             </div>

//           </div>

//         )}

//       </nav>

//       {/* =========================
//           MAIN CONTENT
//           ========================= */}

//       <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

//         {title && (

//           <h1
//             className="
//               text-4xl
//               font-bold
//               text-[#3F7373]
//               mb-8
//             "
//             style={{ fontFamily: 'Playfair Display, serif' }}
//           >
//             {title}
//           </h1>

//         )}

//         {children}

//       </main>

//     </div>
//   );
// }

import React, { useState } from 'react';
import { useAuth } from '../App';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { LogOut, Menu, X } from 'lucide-react';
import logo from './logo.jpeg';

export default function Layout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const role = user?.role?.toLowerCase();
  const appliRole = user?.appli_role?.toLowerCase();
  const careRole = user?.care_role?.toLowerCase();

  const isChef = appliRole === 'chef';
  const isCoordinateur =
    role === 'coordinateur' || careRole === 'coordinateur';

  let navItems = [];

  if (role === 'admin') {
    navItems = [
      { path: '/dashboard', label: 'Accueil' },
      { path: '/users', label: 'Utilisateurs' },
      { path: '/institutions', label: 'Établissements' },
      { path: '/prestations', label: 'Prestations' },
      {
        path: '/remplacements-domicile-admin',
        label: 'Remplacements domicile',
      },
      { path: '/profile', label: 'Profil' },
      { path: '/admin-notifications', label: 'Admin notifs' },
      { path: '/admin-echanges', label: 'Échanges prestations' },
      { path: '/soins', label: 'Soins à domicile' },
      // { path: '/direction', label: 'Dashboard-Direction' },
      // { path: '/admin/payments', label: 'Paiements' },
    ];
  } else if (isChef) {
    navItems = [
      { path: '/prestations', label: 'Prestations' },
      { path: '/prestations-admin', label: 'Prestations admin' },
      {
        path: '/remplacements-domicile-admin',
        label: 'Remplacements domicile',
      },
      { path: '/institutions', label: 'Établissements' },
      { path: '/profile', label: 'Profil' },
      { path: '/soins', label: 'Soins à domicile' },
      { path: '/user-payrolls', label: 'Facturations' },
    ];
  } else if (isCoordinateur) {
    navItems = [
      { path: '/prestations', label: 'Prestations' },
      {
        path: '/remplacements-domicile-admin',
        label: 'Remplacements domicile',
      },
      { path: '/profile', label: 'Profil' },
      { path: '/soins', label: 'Soins à domicile' },
    ];
  } else if (role === 'institution') {
    navItems = [
      { path: '/institution-dashboard', label: 'Dashboard' },
      { path: '/profile', label: 'Profil' },
      {
        path: '/institution-dashboard/tarifications',
        label: 'Tarifications',
      },
      { path: '/payrolls', label: 'Facturation' },
    ];
  } else if (role === 'titulaire_domicile') {
    navItems = [
      { path: '/titulaire-dashboard', label: 'Accueil' },
      {
        path: '/remplacements-domicile',
        label: 'Mes demandes',
      },
      {
        path: '/remplacements-domicile/nouveau',
        label: 'Nouvelle demande',
      },
      { path: '/profile', label: 'Profil' },
    ];
  } else if (['nurse', 'caregiver'].includes(role)) {
    navItems = [
      { path: '/prestations', label: 'Mes Prestations' },
      { path: '/soins', label: 'Soins à domicile' },
      { path: '/profile', label: 'Profil' },
      { path: '/user-payrolls', label: 'Facturations' },
    ];
  } else {
    navItems = [
      { path: '/dashboard', label: 'Dashboard' },
      { path: '/prestations', label: 'Prestations' },
      { path: '/profile', label: 'Profil' },
      { path: '/notifications', label: 'Notifications' },
      { path: '/soins', label: 'Soins à domicile' },
    ];
  }

  const logoPath =
    role === 'institution'
      ? '/institution-dashboard'
      : role === 'titulaire_domicile'
        ? '/titulaire-dashboard'
        : '/dashboard';

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F2F9F9] via-[#D4EBEB] to-[#E8F4F4]">
      <nav className="navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
          <Link to={logoPath} className="flex items-center">
            <img
              src={logo}
              alt="SanaCare"
              className="h-16 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex space-x-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="
                  px-3 py-2
                  rounded-lg
                  text-sm
                  font-medium
                  text-[#3F5F5F]
                  hover:bg-[#D4EBEB]
                  hover:text-[#294A4A]
                  transition
                "
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="text-right">
                <p className="text-sm font-semibold text-[#3F7373]">
                  {user?.first_name} {user?.last_name}
                </p>

                <p className="text-xs text-[#647878]">
                  {role === 'titulaire_domicile'
                    ? 'Titulaire soins à domicile'
                    : user?.role}
                </p>
              </div>
            </div>

            <Button
              onClick={handleLogout}
              variant="outline"
              size="sm"
              className="
                border-[#8FBDBD]
                text-[#4F8585]
                bg-white
                hover:bg-[#D4EBEB]
                hover:text-[#294A4A]
                hover:border-[#6FAFAF]
              "
            >
              <LogOut size={16} className="mr-1" />
              Déconnexion
            </Button>
          </div>

          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#4F8585] hover:bg-[#D4EBEB]"
            >
              {mobileMenuOpen ? <X /> : <Menu />}
            </Button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C1DDDD]">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className="
                    block
                    px-3
                    py-2
                    rounded-lg
                    text-base
                    font-medium
                    text-[#3F5F5F]
                    hover:bg-[#D4EBEB]
                    hover:text-[#294A4A]
                    transition
                  "
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}

              <Button
                onClick={handleLogout}
                variant="outline"
                className="
                  w-full
                  mt-2
                  border-[#8FBDBD]
                  text-[#4F8585]
                  hover:bg-[#D4EBEB]
                  hover:text-[#294A4A]
                "
              >
                <LogOut size={16} className="mr-2" />
                Déconnexion
              </Button>
            </div>
          </div>
        )}
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {title && (
          <h1
            className="
              text-4xl
              font-bold
              text-[#3F7373]
              mb-8
            "
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {title}
          </h1>
        )}

        {children}
      </main>
    </div>
  );
}
